<template>
    <div>
        <div class="backImg max-contain"></div>
        <div class="content">
            <div class="top">
                <div class="top-info">
                    <div class="top-title">全球跨境电商物流綜合服务商</div>
                    <div class="top-button" @click="$router.push({ path: '/about' })">查看详情</div>
                </div>
                <div class="top-img-shadow"></div>

            </div>
            <div class="main">
                <div class="main-number-info">
                    <div :class="{'main-number-info-item':true,'end-item':index===2,'middle-item':index==1}" v-for="(item, index) in infoList" :key="index">
                        <img :src="item.img" alt="">
                        <div class="title">{{ item.title }}
                            <div class="plus">+</div>
                        </div>

                        <div class="desc">
                            <div class="line"></div>{{ item.desc }}
                        </div>

                    </div>
                </div>
                <div class="main-business-scope">
                    <div class="title">业务辐射范围</div>
                    <el-divider>BUSSINESS SCOPE</el-divider>
                    <div class="business-scope"></div>
                    <div class="bussiness-scope-info">
                        <img src="../assets/other/index2.png" alt="">
                        <div class="text">
                            <div class="text-item">
                                <span class="round-icon"></span>
                                业务足迹遍布北美、南美、欧洲、澳洲、中东、东南亚等主要电商目的地，保持与LATAM、BA、TK、MSK等知名航司长期合作伙伴关系，与众多国际公司在跨境电商有着紧密合作。
                            </div>
                            <div class="text-item"><span
                                    class="round-icon"></span>总公司洋泽集团目前在内地及香港有7个分支机构，同时参股美国、德国、荷兰、英国、挪威、越南等多家海外公司，迅速完成国际划布局，满足跨境电商出海需要。
                            </div>

                        </div>
                    </div>
                </div>
                <div class="main-characteristic-service">
                    <div class="title">特色服务</div>
                    <div class="line-dec">INDUSTRIAL SERVICE</div>
                    <div class="text">
                        <div v-for="(item, index) in serviceInfo" :key="index" class="text-item">
                            <div class="name">{{ item.name }}</div>
                            <div>{{ item.desc }}</div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    name: 'Index',
    data() {
        return {
            infoList: [
                {
                    img: require('../assets/other/main-number1.png'),
                    title: '700吨',
                    desc: '月均出货水平'
                },
                {
                    img: require('../assets/other/main-number2.png'),
                    title: '100万',
                    desc: '日均处理包裹数'
                },
                {
                    img: require('../assets/other/main-number3.png'),
                    title: '10年',
                    desc: '国际空运行业经验'
                }
            ],
            serviceInfo: [
                {
                    name: '空运代理',
                    desc: '团队超过十年以上国际空运行业经验,擅长提供量身定制的运输服务'
                },
                {
                    name: '仓储服务',
                    desc: '在东莞、广州、义乌、肇庆，深圳等地开设有运营仓库，占地面积将近36000㎡'
                },
                {
                    name: "国内运输",
                    desc: '专业车队，随时为客户提供到厂提货,和派送服务'
                }
            ]
        }
    },
    methods: {},
    mounted() {

    },
    computed: {

    },
}
</script>
<style lang="less" scoped>
.backImg {
    background-image: url('../assets/other/index1.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 672px;
    width: 100%;
    z-index: -1;
    position: fixed;
    top: 0;
}

.top {
    position: relative;
    height: 637px;
    width: 100%;
    display: flex;
    justify-content: center;
}

.top-info {
    z-index: 9;
    margin-top: 250px;
}

.top-title {
    font-size: 64px;
    color: #FFFFFF;
}

.top-button {
    width: 140px;
    height: 40px;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 2px;
    background: rgba(255, 255, 255, 0.2);
    text-align: center;
    line-height: 40px;
    margin: 0px auto;
    margin-top: 80px;

    &:hover {
        cursor: pointer;
    }
}

.top-img-shadow {
    background: rgba(0, 0, 0, 0.3);
    height: 637px;
    width: 100%;
    position: absolute;
    top: 0;
}
.line-dec {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 12px;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            left: 20px;
            top: 19px;
            z-index: 1;
            background-color: #ddd;
            width: 40%;
            height: 0.5px;
        }

        &::after {
            content: '';
            position: absolute;
            right: 20px;
            top: 19px;
            z-index: 1;
            background-color: #ddd;
            width: 40%;
            height: 0.5px;
        }

    }
.main-number-info {
    padding: 60px 0px;
    display: flex;
    justify-content: space-evenly;
    background: #fff;

    .main-number-info-item {
        color: #00309F;
        height: 290px;
        width: 160px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        font-weight: 600;


        img {
            width: 85px;
            height: 90px;
            object-fit: contain;
        }

        .title {
            font-size: 55px;
            position: relative;

            .plus {
                position: absolute;
                top: -20px;
                right: -20px;
                font-size: 24px;
                font-weight: 800;

            }
        }

        .desc {
            font-size: 24px;
            white-space: nowrap;
            position: relative;

            .line {
                position: absolute;
                top: -24px;
                left: 58px;
                width: 34px;
                height: 4px;
                background-color: #4c4c4c;
            }
        }
    }
    .end-item{
        .line {
                left: 74px !important;
            }

            
    }
    .middle-item{
        .line {
                left: 69px !important;
            }

    }

}

.main-business-scope {
    background: #fff;
    padding-bottom: 15px;

 

    .title {
        font-size: 24px;
        text-align: center;
    }

    .eng-title {
        text-decoration: line-through;
        font-size: 12px;
    }

    .business-scope {
        height: 600px;
        width: 100%;
        background-image: url('../assets/other/map.png');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;

    }

    .bussiness-scope-info {
        height: 120px;
        width: 80%;
        border: 2px solid #D7D7D7;
        display: flex;
        align-items: center;
        margin: 15px auto;
        font-size: 12px;
        padding: 0 20px;

        img {
            margin-right: 15px;
        }

        .round-icon {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #00309F;
            margin-right: 6px;
        }

        .text-item {
            padding: 8px;
        }
    }
}

.main-characteristic-service {
    background: rgba(0, 0, 0, 0.5);
    height: 552px;
    width: 100%;
    padding-top: 50px;
    box-sizing: border-box;
    color: #fff;

    .el-divider__text {
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
    }

    .title {
        font-size: 24px;
        text-align: center;
    }

    .text {
        display: flex;
        justify-content: space-evenly;
        margin-top: 100px;
    }

    .text-item {
        width: 280px;
        height: 170px;
        padding: 0 15px;
        background: rgba(255, 255, 255, 0.3);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        text-align: center;
        line-height: 30px;

        .name {
            font-size: 20px;
            font-weight: 500;
            margin-bottom: 10px;
        }

        &:hover {
            background-color: rgba(0, 0, 0, 0.5);
            // opacity: 0.5;
            cursor: pointer;
            border-bottom: 2px solid #3399FF;
        }
    }
}
</style>